import Link from 'next/link';
import i18n from '@/settings/i18n';
import { generateCategoryPageUrl } from '@/components/category/helpers';

const t = i18n.init('shared');

const MenuItem = ({
  handle,
  title,
  pk,
}: {
  handle?: string;
  pk?: string;
  title: string;
}) => {
  const link = handle
    ? `/collections/${handle}`
    : generateCategoryPageUrl(title, pk as string);

  return (
    <li
      key={handle}
      // eslint-disable-next-line tailwindcss/no-custom-classname
      className="relative h-full"
    >
      <Link
        href={link}
        prefetch={false}
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className="fancy-underline whitespace-nowrap font-medium outline-none"
      >
        {t(title)}
      </Link>
    </li>
  );
};

export default MenuItem;
